import { assetMediaSchema, type AssetMedia } from '@aikoa/common'
import { useTranslations } from '@aikoa/i18n/react'
import { z } from 'zod/v4'
import { PropertyMedia } from '~/components/assets/profile/PropertyMedia.tsx'
import { PhaseWrapper } from '~/components/flows/phases/PhaseWrapper.tsx'
import { ViewTitle } from '~/components/layout/Sections.tsx'

export const mediaPhaseSchema = z.object({
  media: z.array(assetMediaSchema),
})

export type MediaPhaseData = z.infer<typeof mediaPhaseSchema>

export function MediaPhase({
  mediaData,
  onMediaUpdate,
}: {
  mediaData: MediaPhaseData
  onMediaUpdate: (newMedia: AssetMedia[]) => void
}) {
  const { t } = useTranslations('property')

  return (
    <PhaseWrapper>
      <ViewTitle>{t(($) => $.flow.media.title)}</ViewTitle>
      <PropertyMedia media={mediaData.media} onMediaUpdate={onMediaUpdate} />
    </PhaseWrapper>
  )
}
